<template>
  <div class="interests-select" @click.stop="isOpen = !isOpen" v-on-clickaway="close">
    {{ localValue || placeholder }}
    <img src="/images/menu-dropdown.svg" :class="{ 'rotate-180': isOpen }" alt="" />
    <div v-show="isOpen" class="interest-dropdown">
      <ul>
        <li v-for="option in options" @click.stop="select(option)">{{ option }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import HasLocalValue from '../mixins/HasLocalValue';

export default {
  mixins: [HasLocalValue],

  directives: { onClickaway },

  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select...',
    },
  },

  data () {
    return {
      isOpen: false,
    }
  },

  methods: {
    select(option) {
      this.localValue = option
      this.isOpen = false
    },

    close () {
      this.isOpen = false
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../sass/core/variables.scss";
.interests-select {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 45px;
    padding: 10.5px 15.5px;

    color: rgba(#050B2D, .5);
    font-size: 14px;
    letter-spacing: 0.16px;
    line-height: 20px;

    background: white;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    outline: none;
    transition: all .5s ease-in-out;
    text-align: left;

    &:hover, &:focus {
        background: #f1f1f1;
        border: 1px solid $color-2;
        transition: all .5s ease-in;
    }

    img {
      position: absolute;
      right: 16px;
      top: 19px;
    }

    .interest-dropdown {
      position: absolute;
      top: 45px;
      left: 0;
      max-height: 300px;
      width: 100%;
      padding: 15px;

      background-color: #FFFFFF;
      box-shadow: 0 0 4px 0 rgba(0,0,0,0.2);

      ul {
        margin: 0; padding: 0;

        li {
          margin: 0;
          padding: 0 0 10px;
          color: #050B2D;
          font-size: 14px;
          letter-spacing: 0.16px;
          line-height: 20px;

          &:last-child { margin: 0; }
        }
      }
    }
}

</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/SelectDropdown.vue